module.exports = __webpack_public_path__ + "colombia.jpg?85d15b81d1bd7f03202f7e1ba6e8a09e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/colombia.jpg
// module id = 187
// module chunks = 0